import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { Injectable } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PageHeaderModule } from '@stg-js-ngx-core/page-header';
import { OauthSessionModule } from '@stg-js-ngx-core/oauth';
import { FooterModule } from '@stg-js-ngx-core/footer';
import { DesktopModule } from '@stg-js-ngx-core/desktop';
import { LeftNavModule } from '@stg-js-ngx-core/left-nav';
import { HeaderModule } from '@stg-js-ngx-core/header';

@Injectable()
export class ParameterHashLocationStrategy extends HashLocationStrategy {
  prepareExternalUrl(internal: string): string {
    if (window.location.href.indexOf('selfservice') > -1){
      return 'selfservice/' + super.prepareExternalUrl(internal);
    } else {
      return super.prepareExternalUrl(internal);
    }
  }
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
        BrowserModule,
        PageHeaderModule,
        AppRoutingModule,
        OauthSessionModule.forRoot(),
        FooterModule,
        DesktopModule,
        LeftNavModule,
        HeaderModule,
        FormsModule
    ],
  providers: [
    { provide: LocationStrategy, useClass: ParameterHashLocationStrategy },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
